import { defineStore } from "pinia";
import Services from '@/services/sutting/districtsServices'
import { mapList2Level, mapDistrict } from '@/helpers/mapFuncs'

export const useDistrictsStore = defineStore("districts", {
persist: true,
state:()=>({
    district: {},
    districts: [],
}),
getters : {
    getDistrict() {
        return mapDistrict(this.district)
    },
    getDistricts() {
        return this.districts.map(mapDistrict)
    },
    getDistrictsList2Level() {
        return this.districts.map(mapList2Level)
    }
},
actions : {
    /** Start Sets */
    setDistrict(district) {
        this.district = district
    },
    setDistricts(districts) {
        this.districts = districts
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setDistrict(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setDistricts(response.data.data??[])
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.districts.push(response.data.data)
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.districts[this.districts.findIndex((x)=>x.id == id)] = response.data.data
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.districts = this.districts.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});
